import React from 'react';
import ReactDOM from 'react-dom/client';

import './virtual:windi.css';
import 'extra.css';
import 'firebaseui/dist/firebaseui.css';

import App from 'App';
import Maintenance from 'pages/Maintenance';
import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import reportWebVitals from 'reportWebVitals';
import { MAINTENANCE_MODE } from 'config';


console.log('MAINTENANCE_MODE', MAINTENANCE_MODE);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {MAINTENANCE_MODE === 'true'
      ? <Maintenance />
      : <App />}
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
